module.exports = __webpack_public_path__ + "img/1.7fa4a016.png";